import { HOST_API_BASE_URL } from 'services/connections.service';

const config = {
  searchKitProductListAPIEndPoint: `${HOST_API_BASE_URL}/product-listing`,
};

export default config;
